const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user overview component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminUserOverview', ['Application', 'AdminUsers', 'AccessHelper', function(Application, AdminUsers, AccessHelper) {
  return {
    restrict: 'E',
    scope: {
      showHide: '=',
      restrictions: '=',
      singleChoice: '@',
      suspended: '='
    },
    template: require('../../templates/directives/admin-user-overview.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var userId = Application.navigation.getRouteParameters().id;
      self.flags = Application.features.flags();
      self.checked = false;
      self.currentTab = '';

      self.allowance = {
        add: AccessHelper.isAllowed(['admin', 'users', 'add'], null, ['admin']),
        edit: AccessHelper.isAllowed(['admin', 'users', 'edit'], null, ['admin']),
        view: AccessHelper.isAllowed(['admin', 'users', 'view'], null, ['admin']),
        suspend: AccessHelper.isAllowed(['admin', 'users', 'suspend'], null, ['admin']),
        password_reset: AccessHelper.isAllowed(['admin', 'users', 'password_reset'], null, ['admin']),
        view_user_activity: AccessHelper.isAllowed(['admin', 'users', 'view_user_activity'], null, ['admin'])
      };

      self.accessed = {
        "general": false,
        "assigned": false,
        "viewed": false,
        "tracks": false,
        "workshops": false,
        "badges": false
      }
      self.updateCurrentTab = function(t){
        self.currentTab = t;
      }
      self.changeTab = function(tab) {
        self.accessed[tab] = true;
        self.updateCurrentTab(tab);
      }

      if (!$scope.suspended && !self.allowance.edit) {
        self.currentTab = 'viewed';
        self.accessed.viewed = true;
      } else {
        self.accessed.general = true;
        self.currentTab = 'general';
      }

      $scope.assignUser = userId;

      AdminUsers.get({subresource: userId, suspended: $scope.suspended ? true : false}).$promise
      .then(function(results) {
        if (!results._id) {
          Application.navigation.goTo('/explore');
          return;
        }
        self.checked = true;
      });

    }],
    controllerAs: 'userOverview'
  }
}]);